import { render, staticRenderFns } from "./contact-details-modal.vue?vue&type=template&id=bc8fcae0&scoped=true&"
import script from "./contact-details-modal.vue?vue&type=script&lang=js&"
export * from "./contact-details-modal.vue?vue&type=script&lang=js&"
import style0 from "./contact-details-modal.vue?vue&type=style&index=0&id=bc8fcae0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8fcae0",
  null
  
)

export default component.exports